import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/nominas/descuentos-carga-externa-vista-optimized';
export const baseURI2 = '/nominas/descuentos-carga-externa';
/**
 * GET
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getConfiguracionExternaDescuentos = async (params) => {
  try {
    const response = await API.get(baseURI2, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getConfiguracionExternaDescuento = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConfiguracionExternaDescuento = async (values) => {
  try {
    const response = await API.post(baseURI2, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchConfiguracionExternaDescuento = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI2}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteConfiguracionExternaDescuento = async (id) => {
  try {
    const response = await API.delete(`${baseURI2}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const autorizarConfiguracionExternaDescuento = async (id) => {
  try {
    const response = await API.patch(`${baseURI2}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
